var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dynamic-vector-properties-wrapper" },
    [
      _c(
        _setup.ElementLibrarySelector,
        {
          attrs: {
            disabled: _setup.disabled.common,
            readonly: _vm.previewMode,
            "element-list": _setup.model.vectorMap,
            "library-id": _setup.model.vectorLibraryId,
            "library-type": _setup.VECTOR_TYPE,
            "selected-position": _setup.model.vectorOption,
            "mixed-library": _setup.model.isLibraryIdMixed,
            "mixed-element-list": _setup.model.isVectorMapMixed,
            "element-list-position": 3,
          },
          on: {
            "files-uploaded": _setup.onVectorUpload,
            "load-option": _setup.onLoadOption,
            "options-reordered": _setup.onVectorOptionsReordered,
            "remove-map-option": _setup.removeVectorOptionFromMap,
            "remove-library": _setup.removeVectorLibrary,
            "pick-library": function ($event) {
              return _setup.emit("open-vector-library-selector")
            },
          },
        },
        [
          _c(
            "template",
            { slot: _setup.currentSlot },
            [
              _c(_setup.CInput, {
                staticClass: "w-25 no-fill",
                attrs: {
                  label: "Element ID",
                  type: "number",
                  placeholder: _setup.elementIdPlaceholder,
                  min: 1,
                  disabled: _setup.disabled.elementId,
                  pattern: /^[1-9]\d*$/,
                },
                on: { input: _setup.updateElementId },
                model: {
                  value: _setup.model.elementId,
                  callback: function ($$v) {
                    _vm.$set(_setup.model, "elementId", $$v)
                  },
                  expression: "model.elementId",
                },
              }),
              _vm._v(" "),
              _vm.previewMode
                ? _c(_setup.CButton, {
                    staticClass: "align-self-end",
                    attrs: {
                      variant: "secondary",
                      text: "Replace with image",
                      disabled: _setup.disabled.common,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.emit("image-replace")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }